<app-header></app-header>

<div class="home-page-container">
  <section class="introduction-container">
    <section class="caption-container">
      <h1>
        Rooted in <br />
        Tomorrow.
      </h1>
    </section>
    <section class="title-container">
      <hr />
      <p>
        Spruce: innovating easy access <br />
        to sustainable energy for a brighter tomorrow
      </p>
    </section>
    <section class="scroll-container ">
      <a (click)="scrollToSection()" class="show-cursor">
        <div class="down-arrow">
          <i class="fa-solid fa-angle-down"></i>
        </div>
      </a>
    </section>
  </section>
  <br />
  <br />
  <section class="about-container container" id="main-content">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-6">
        <div class="focus-details-container">
          <div class="spruce-focus-container">
            <h1 class="home-heading">At Spruce, we focus on clean energy solutions</h1>
            <p>
              Spruce Power is a leading owner and operator of distributed solar
              energy assets across the United States. Spruce is able to make renewable energy more accessible to everyone.
            </p>
            <p>
              Working together with our customers and partners, we relentlessly
              pursue opportunities to create a cleaner and more sustainable future.
              We lead the way by creating accessible and reliable solutions to
              deliver on our promise to harness the power of nature.
            </p>
          </div>
          <div class="numbers-container row mt-5">
            <div class="col-12 col-lg-6 ps-0">
              <div class="left-numbers-container">
                <div class="left-number row">
                  <div class="col-3 number">
                    <div class="number"><h6>15<span class="unit-smaller">Years</span></h6></div>
                  </div>
                  <div class="col-9 description">Number of years Spruce has been servicing solar and energy efficiency assets.</div>
                </div>
                <div class="left-number row">
                  <div class="col-3 number">
                    <h6>~85<span class="unit-smaller">k</span></h6>
                  </div>
                  <div class="col-9 description">
                    Residential solar systems owned
                  </div>
                </div>
                <div class="left-number row">
                  <div class="col-3 number">
                    <h6>~145<span class="unit-smaller">k</span></h6>
                  </div>
                  <div class="col-9 description">Number of assets managed.</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 ps-0">
              <div class="right-numbers-container">
                <div class="right-number row">
                  <div class="number col-3 col-lg-4">
                    <h6>~$1<span class="unit-smaller">B</span></h6>
                  </div>
                  <div class="col-9 col-lg-8 description">Residential solar assets serviced.</div>
                </div>
                <div class="right-number row">
                  <div class="number col-3 col-lg-4">
                    <h6>~2.2<span class="unit-smaller">B</span></h6>
                  </div>
                  <div class="col-9 col-lg-8 description">
                    kWh of lifetime renewable energy generated.
                  </div>
                </div>
                <div class="right-number row">
                  <div class="number col-3 col-lg-4">
                    <h6>~515<span class="unit-smaller">MW</span></h6>
                  </div>
                  <div class="col-9 col-lg-8 description">
                    Installed megawatts of capacity of Spruce’s residential solar systems
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="promise-container mt-3">
            <strong>Our promise.</strong>
            <p>
              We provide flexible and reliable products, helping homeowners take
              control of their power needs with affordable home energy solutions.
            </p>
            <a [routerLink]="['/about']">Learn More</a>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 col-lg-6">

        <div class="about-image">
          <img src="assets/rainforest.jpg" alt="rainforestImage" />
        </div>
      </div>
    </div>

  </section>
  <section class="services-container">
    <div class="spruce-pro-header container">
      <img src="assets/homepageProImage.png" alt="pro-logo">
      <hr />
      <h3 class="mt-2">Your Premier Full-Scope Managed Services Provider</h3>
      <p class="experience-message">
        <i>Our Experience Equals Your Benefit</i>
      </p>
    </div>
  <div class="home-pro-section" onclick="window.location.href='/pro'">
    <button>Learn More</button>
  </div>

  </section>
  <section class="questions-help-container pt-5 pb-5">
    <h1>Other questions or help?</h1>
    <button type="button" class="btn" [routerLink]="['/get-in-touch']">
      Contact Us
    </button>
    <button type="button" class="btn" [routerLink]="['/faq']">FAQs</button>
  </section>
</div>
<app-footer></app-footer>
